import React, { Component } from 'react';
import './style/Recarga.css';
import './style/normalize.css';
import iconcel from './images/iconcel.png';
import iconMoney from './images/iconMoney.png';
import NumberFormat_ from 'react-number-format';
import axios from 'axios';
import Swal from 'sweetalert2';
import Payment from './components/payment'; 
import Menu from './components/menu'; 
import { Redirect  } from 'react-router-dom';

class Recarga extends Component {

    constructor(props){

        super(props);
        if(this.props.location.state == undefined) {
            window.history.back();
            return;
        }
        this.state = {
            numberFormat: this.props.location.state.numberFormat,
            number: this.props.location.state.number,
            numberFixed: this.props.location.state.number,
            token: this.props.location.state.token,
            newNumber: '',
            showTelefone: false,
            checkRadionumber: false,
            valueList: [],
            valueListFixed: [],
            timeToRedirect: false,
            choosePrice: 0
        }
        this.setState({timeToRedirect: false}); 
    }

    changeRadioNumber = (event) => {

        this.setState({checkRadionumber: true}); 
        
        if(event.target.value === "newNumber"){
            this.setState({
                showTelefone: true,
                number: ""
            });
        }
        else {
            this.setState({
                showTelefone: false,
                number: this.props.location.state.number,
                valueList: this.state.valueListFixed
            });
            console.log(this.state.valueList);
            console.log(this.state.valueListFixed);
        }
    }

    getVaule = () => {
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/GetValues`, {
            transactionId: new Date().getTime(),
            msisdn: this.state.number
        }, { headers: {"Authorization": "Bearer " + this.state.token } })
        .then(res => {
            if(res.data.code == "P00"){
                this.setState({valueList: res.data.valueList}); 
                if(this.state.valueListFixed.length === 0){
                    this.setState({valueListFixed: res.data.valueList}); 
                }
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.msg,
                    type: 'error'
                }).then((result) => {
                    this.setState({timeToRedirect: true}); 
                }); 
            }

        })
        .catch(res => {

            Swal.fire({
            title: 'Erro!',
            text: "Erro ao carregar os valores!",
            type: 'error'
            }).then((result) => {
            this.setState({timeToRedirect: true}); 
            })
        })
    }

    getVauleNewPhone = (type) => {
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/GetValues`, {
            transactionId: new Date().getTime(),
            msisdn: this.state.numberFixed,
            type: type
        }, { headers: {"Authorization": "Bearer " + this.state.token } })
        .then(res => {
            if(res.data.code == "P00"){
                this.setState({valueList: res.data.valueList}); 
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.msg,
                    type: 'error'
                }).then((result) => {
                    this.setState({timeToRedirect: true}); 
                }); 
            }

        })
        .catch(res => {

            Swal.fire({
            title: 'Erro!',
            text: "Erro ao carregar os valores!",
            type: 'error'
            }).then((result) => {
            this.setState({timeToRedirect: true}); 
            })
        })
    }

    componentDidMount() {
        this.getVaule();
    }

    changePrince = (event) => {
        this.setState({choosePrice: event.target.value});        
    }

    render() {

        if(this.state.timeToRedirect){
            return <Redirect to="/"/>
        }

        const showTelefone = this.state.showTelefone ? 'showTelefone' : '';


        return (
            <div className="content-recharge-all recharge">
                <div className="content-recharge--coluns">
                    <div className="content-recharge content-recharge--1">
                        <span onClick={() => this.menuRef.openMenu()} id="menu">☰</span>
                        <img src={iconcel} className="icon-col"/>
                        <h3>QUAL NÚMERO <br/> DESEJA CARREGAR?</h3>
                        <div className="content-recharge--list">
                            <ul>
                                <li>
                                    <input onChange={this.changeRadioNumber} type="radio" id="number_1" name="number" value={this.state.number} defaultChecked={true} />
                                    <label for="number_1">{this.props.location.state.numberFormat}</label>
                                </li>
                                <li>
                                    <input onChange={this.changeRadioNumber} type="radio" id="number_2" name="number" value="newNumber"/>
                                    <label for="number_2">NOVO TELEFONE</label>
                                </li>
                            </ul>
                            <div className={`shellNovoTelefone ${showTelefone}`}>
                                <h2>DIGITE O TELEFONE QUE<br/>RECEBERÁ A REGARGA</h2>
                                <NumberFormat_ className="number" placeholder="DDD + Telefone" 
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        this.setState({number: value});
                                        if((value.length >= 10)&&(this.state.showTelefone)){
                                            const digit = value.toString()[2];
                                            const type = (parseInt(digit) < 6) ? 'F' : 'C';
                                            this.getVauleNewPhone(type);
                                        }
                                    }} 
                                    value={this.state.number} format={this.state.number.toString().length > 10 ?  "(##) #####-####" : "(##) ####-#####"}  />
                            </div>
                        </div>
                    </div>
                    <div className="content-recharge content-recharge--2">
                        <img src={iconMoney} className="icon-col"/>
                        <h3>SELECIONE O <br /> VALOR DA RECARGA</h3>
                        <div className="content-price--list">
                            <ul>
                                
                                {this.state.valueList.map((item,i) => 
                                    <li key={i}>
                                        <input onChange={this.changePrince}  type="radio" id={item.value} name="price" value={item.value}/>
                                        <label for={item.value}>
                                            <img src={require(`./images/${item.value}.png`)}/>
                                        </label>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <Payment number={this.state.number} choosePrice={this.state.choosePrice} token={this.state.token} numberFormat={this.state.numberFormat} numberFixed={this.state.numberFixed}/>
                </div>
                <Menu ref={el => this.menuRef = el} number={this.state.number} numberFormat={this.state.numberFormat} token={this.state.token}/>
            </div>
        )
    }


}

export default Recarga;
